<template>
  <div>
    <!-- <Card1></Card1> -->
    <base-card
      :listTitle="this.listTitle"
      :listContent="this.listContent"
      :listUrl="this.listUrl"
      :total="this.total"
      @currentPageChange="handlePageChange"
    ></base-card>
    <base-box :key="this.reRenderKey" :article="this.article"></base-box>
  </div>
</template>

<script>
import BaseCard from "../components/BaseCard.vue";
import BaseBox from "../components/BaseBox.vue";
import getPath from "../utils/getPath";
import getArticleList from "../utils/getArticleList";
import getArticleCount from "../utils/getArticleCount";

export default {
  components: {
    BaseCard,
    BaseBox
  },
  data() {
    return {
      article: {},
      listTitle: "",
      listContent: {},
      listUrl: "",
      total: 0,
      isRender: false,
      reRenderKey: 0
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        getPath(this.$http, newVal, "/huayin/show-edit-article/").then(res => {
          this.article.title = res.data.data[0].title;
          this.article.content = res.data.data[0].content;
          this.forceRerender();
        });
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    getArticleCount(this.$http, "/huayin/get-articles-count").then(res => {
      this.total = res.data.data[0]["COUNT(*)"] - 16;
    });
    getArticleList(this.$http, "/huayin/get-articles", "", "", "3", "8").then(
      articleList => {
        this.listContent = articleList.data.data;
        this.listTitle = "基金报告";
        this.listUrl = "/#/fund/";
      }
    );
  },
  methods: {
    forceRerender() {
      this.reRenderKey += 1;
    },
    async handlePageChange(val) {
      getArticleList(
        this.$http,
        "/huayin/get-articles",
        "",
        "",
        val + 2,
        "8"
      ).then(articleList => {
        this.listContent = articleList.data.data;
        this.listTitle = "基金报告";
        this.listUrl = "/#/fund/";
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/fund.vue